import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { loadAdvisorData, loadAdvisorDataSuccess, loadAdvisorDataFailure } from '../actions/advisors.actions';
import { environment } from 'src/environments/environment';
import { selectAdvisorData } from '../selectors/advisors.selector';
import { select, Store } from '@ngrx/store';
import { decompress } from 'compress-json';
import { decryption } from 'src/app/common-functions';

// @Injectable()
// export class AdvisorEffects {
//   loadAdvisorData$;
//   constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
//     this.loadAdvisorData$ = createEffect(() =>
//       this.actions$.pipe(
//         ofType(loadAdvisorData),
//         withLatestFrom(this.store.pipe(select(selectAdvisorData))),
//         switchMap(([action, currentData]) => {
//           console.log(currentData)
//           if (currentData != undefined && currentData.length > 0) {
//             console.log('Data already in store, no need to call API');
//             console.log('return old fetch',new Date().toISOString())
//             return;
//             // return [loadAdvisorDataSuccess({ advisorData: currentData })]; // Return the existing data
//           }

//           const api = this.getApiEndpoint();
//           const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
//           const headers = {
//             'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
//             'Content-Type': 'application/json'
//           };
//           return this.http.get<any>(apiUrl, { headers }).pipe(
//             map((data) => {
//               console.log('Fetched new data:', data);
//               console.log('new fetch',new Date().toISOString())
//               const role = sessionStorage.getItem('role')
//               if(role=='ADMINISTRATOR'){
//                 const brokerList = decompress(data.data)
//                 return loadAdvisorDataSuccess({ advisorData: brokerList }); // Dispatch success with new data
//               }else{
//                 const brokerList = data.data
//                 return loadAdvisorDataSuccess({ advisorData: brokerList }); // Dispatch success with new data
//               }
//               // return data.advisorData
//             }),
//             catchError((error) => {
//               console.error('API Error:', error);
//               const errorMessage = error?.message || 'An unknown error occurred';
//               return [loadAdvisorDataFailure({ error: errorMessage })]; // Dispatch failure on error
//             })
//           );
//         })
//       )
//     );
//   }

//   private getApiEndpoint(): string {
//     const role = sessionStorage.getItem('role');
//     console.log('Role from sessionStorage:', role);
//     if (!role || role === 'USER') {
//       return '/api/ap/brokers/details';
//     } else if (role === 'ADMINISTRATOR') {
//       return '/api/ap/global/adminAdvisors';
//     } else {
//       return '/api/ap/brokers/details';
//     }
//   }
// }

// 2nd 
@Injectable()
export class AdvisorEffects {
  loadAdvisorData$;
  constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
    this.loadAdvisorData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadAdvisorData),
        withLatestFrom(this.store.pipe(select(selectAdvisorData))),
        switchMap(([action, currentData]) => {
          // if (currentData != undefined && currentData.length > 0) {
          //   console.log('Data already in store, no need to call API');
          //   console.log('return old fetch',new Date().toISOString())
          //   return;
          //   // return [loadAdvisorDataSuccess({ advisorData: currentData })]; // Return the existing data
          // }

          const api = this.getApiEndpoint();
          const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
          const headers = {
            'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json'
          };

          return this.http.get<any>(apiUrl, { headers }).pipe(
            map((data) => {
              console.log('Fetched new data:', data);
              console.log('New fetch', new Date().toISOString());
              
              if (data && data.data && data.data.length > 0) {
                console.log('entered advisorData udpation')
                // API returned data, replace both sessionStorage and store
                
                const role = sessionStorage.getItem('role');
                let dataToStore = data.data;
                
                if (role == 'ADMINISTRATOR') {
                  sessionStorage.setItem('advisorData', JSON.stringify(decompress(data.data)));
                  // Decompress data if role is ADMINISTRATOR
                  dataToStore = decompress(data.data);

                  dataToStore = dataToStore.map((customer: any)=>JSON.parse(decryption(customer)));
                }

                return loadAdvisorDataSuccess({ advisorData: dataToStore });
              } else {
                // API returned no data, use sessionStorage data if available
                const cachedData = sessionStorage.getItem('advisorData');

                if (cachedData) {
                  console.log('Returning data from sessionStorage', new Date().toISOString());
                  return loadAdvisorDataSuccess({ advisorData: JSON.parse(cachedData) });
                } else {
                  console.log('No data in sessionStorage', new Date().toISOString());
                  return loadAdvisorDataFailure({ error: 'No advisor data available' });
                }
              }
            }),
            catchError((error) => {
              console.error('API Error:', error);
              const errorMessage = error?.message || 'An unknown error occurred';
              return [loadAdvisorDataFailure({ error: errorMessage })];
            })
          );
        })
      )
    );
  }

   private getApiEndpoint(): string {
    const role = sessionStorage.getItem('role');
    console.log('Role from sessionStorage:', role);
    if (!role || role === 'USER') {
      return '/api/ap/brokers/details';
    } else if (role === 'ADMINISTRATOR') {
      return '/api/ap/global/adminAdvisors';
    } else {
      const adminId = sessionStorage.getItem('groupAdminId');
      if(adminId && adminId != '' && adminId != undefined && adminId != null){
        return '/api/ap/v2/brokers/details/' + adminId;
      }else{
        return '/api/ap/brokers/details';
      }
    }
  }
}

